import * as React from "react";

import { CommonControlProps } from "@common/components/Atoms/FormInputs/commonControlProps";
import { IconCheck, IconFrown } from "@common/components/Atoms/Icons";

interface TextAreaProps extends CommonControlProps {
    autoComplete?: "Off" | "On";
    description?: string;
    inputControl?: any;
    isValid: boolean;
    label?: string;
    maxLength?: number;
    name: string;
    placeholder?: string;
    readOnly?: boolean;
    required?: boolean;
    validationMessages: string[];
    value?: string;
    setRef?: (ref: any) => void;
    rows?: number;
    dataCy?: string;
}

interface TextAreaState {
    charsLeft: string | number;
}

export class TextArea extends React.Component<TextAreaProps, TextAreaState> {
    static defaultProps = {
        autoComplete: "On",
        isValid: true,
        name: "",
        readOnly: false,
        required: false,
        validationMessages: [],
    };

    constructor(props: TextAreaProps) {
        super(props);
        this.onChange = this.onChange.bind(this);
        this.onBlur = this.onBlur.bind(this);
        this.onFocus = this.onFocus.bind(this);
        this.setRef = this.setRef.bind(this);

        this.state = {
            charsLeft: !!this.props.maxLength ? this.props.maxLength : "",
        };
    }

    onChange(event) {
        if (!!this.props.maxLength) {
            let charcount: string | number =
                this.props.maxLength - event.target.value.length;
            if (charcount < 1) charcount = "";
            this.setState({ charsLeft: charcount });
        }
        if (this.props.onChange) {
            this.props.onChange(this.props.name, event.target.value);
        }
    }

    onBlur() {
        if (this.props.onBlur) this.props.onBlur(this.props.name);
    }

    onFocus() {
        if (this.props.onFocus) this.props.onFocus(this.props.name);
    }

    setRef(ref: any) {
        if (this.props.setRef) this.props.setRef(ref);
    }
    render() {
        return (
            <div className="c-block">
                <div
                    className={
                        "c-control c-control--textarea " +
                        (!this.props.isValid ? "has-error " : "") +
                        (!!this.props.maxLength ? "has-hint " : "")
                    }
                >
                    {this.props.label && (
                        <div className="c-control__label">
                            <label htmlFor={"textarea_" + this.props.name}>
                                {this.props.label}
                            </label>
                            {this.props.description && (
                                <p>{this.props.description}</p>
                            )}
                        </div>
                    )}
                    <div className="c-control__wrapper">
                        <textarea
                            className={
                                "c-control__textarea " +
                                (!this.props.isValid ? "has-error" : "")
                            }
                            id={"textarea_" + this.props.name}
                            name={this.props.name}
                            value={this.props.value}
                            required={this.props.required}
                            readOnly={this.props.readOnly}
                            autoComplete={this.props.autoComplete}
                            onChange={this.onChange}
                            onFocus={this.onFocus}
                            onBlur={this.onBlur}
                            placeholder={this.props.placeholder}
                            maxLength={this.props.maxLength}
                            ref={this.setRef}
                            rows={this.props.rows}
                            data-cy={this.props.dataCy}
                        />
                        {this.props.isValid && (
                            <div
                                className="c-control__valid"
                                id={"textarea-valid_" + this.props.name}
                            >
                                <IconCheck />
                            </div>
                        )}
                    </div>
                    <div className="c-control__message u-text-right">
                        {this.state.charsLeft}
                    </div>
                    {!this.props.isValid && (
                        <div className="c-control__message">
                            <IconFrown />
                            {this.props.validationMessages.map((msg, ind) => (
                                <span
                                    key={ind}
                                    id={"textarea-error_" + this.props.name}
                                >
                                    {msg + " "}
                                </span>
                            ))}
                        </div>
                    )}
                </div>
            </div>
        );
    }
}
